import PropTypes from 'prop-types';

export const props = {
  background: PropTypes.string,
  items: PropTypes.array,
  showHome: PropTypes.bool,
};
